module.exports = __webpack_public_path__ + "static/media/codeUseClaro.2dea9c42.png";